import { types } from "mobx-state-tree";
import { appConfig } from "../config";

const ConfigStore = types
  .model({
    id: types.optional(types.string, "barometer"),
    appName: types.optional(types.string, "BAROMETER"),
    home: types.optional(types.string, "/start"),
    functions_url: types.optional(types.string, "http://localhost:5000"),
    create_new_survey: types.optional(types.boolean, true),
    languages: types.frozen([{ key: "nl_BE", label: "Nederlands" }]),
    email: types.maybeNull(types.string),
    share_prefix: types.maybeNull(types.string),
    register_as_individual: types.optional(types.boolean, true),
    register_as_group: types.optional(types.boolean, false),
    register_register_title: types.optional(types.string, "Registratie"),
    register_register_body: types.optional(types.string, ""),
    register_register_success: types.optional(
      types.string,
      "Er werd een verificatiemail verstuurd naar het e-mailadres dat aan uw account gekoppeld is. Van zodra het emailadres is bevestigd, kan u als begeleider vragenlijsten opstarten en de resulaten na afname opvragen."
    ),
    register_register_group_enable: types.optional(types.string, "Als school/groep invullen?"),
    color1: types.optional(types.string, "#348a66"),
    color2: types.optional(types.string, "#53bc76"),
    background: types.optional(types.string, "background.jpg"),
    field_types: types.frozen([]),
    results: types.frozen([])
  })
  .actions(self => ({
    afterCreate() {
      self.load();
    },
    load() {
      Object.keys(appConfig).forEach(key => {
        self.change(key, appConfig[key]);
      });
    },
    change(key, value) {
      self[key] = value;
    },
    getLabelForFieldType(type) {
      const field = self.field_types.find(field => field.value === type);
      return field && field.value === "fieldset" ? field.label : "Vraag";
    }
  }));

export default ConfigStore;
